// bra-pack landing JS — mobile product carousel + existing landing behavior

(function () {
  'use strict';

  var root = document.querySelector('.landing-bra-pack');
  if (!root) return;

  // =========================================================
  // PRODUCT GALLERY
  // Desktop: main image + thumbnails (igual que ahora)
  // Mobile: swipe carousel + dots + arrows
  // =========================================================

  var mainImg = root.querySelector('.flp-gallery-main img.main') ||
                root.querySelector('.flp-gallery-main img');

  var thumbs = Array.from(root.querySelectorAll('.flp-gallery-thumbs img'));

  var mobileGallery = null;
  var mobileTrack = null;
  var mobileDots = [];
  var mobilePrev = null;
  var mobileNext = null;
  var mobileIndex = 0;
  var mobileScrollRaf = null;

  function isMobileGallery() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function getThumbFull(thumb) {
    return thumb.getAttribute('data-full') ||
           thumb.getAttribute('data-src') ||
           thumb.currentSrc ||
           thumb.src;
  }

  function setMobileActive(index) {
    if (!mobileTrack || !mobileDots.length) return;

    var max = mobileDots.length - 1;
    mobileIndex = Math.max(0, Math.min(index, max));

    mobileDots.forEach(function (dot, i) {
      var active = i === mobileIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });

    if (mobilePrev) mobilePrev.disabled = mobileIndex === 0;
    if (mobileNext) mobileNext.disabled = mobileIndex === max;
  }

  function goToMobileSlide(index, behavior) {
    if (!mobileTrack || !mobileDots.length) return;

    var max = mobileDots.length - 1;
    index = Math.max(0, Math.min(index, max));

    setMobileActive(index);

    if (!isMobileGallery()) return;

    mobileTrack.scrollTo({
      left: index * mobileTrack.clientWidth,
      behavior: behavior || 'smooth'
    });
  }

  function buildMobileGallery() {
    if (!mainImg) return;

    var sources = [];

    if (thumbs.length) {
      thumbs.forEach(function (thumb) {
        var src = getThumbFull(thumb);
        if (!src) return;

        sources.push({
          src: src,
          alt: thumb.alt || mainImg.alt || 'Brasier Sin Varillas'
        });
      });
    }

    if (!sources.length && mainImg.src) {
      sources.push({
        src: mainImg.currentSrc || mainImg.src,
        alt: mainImg.alt || 'Brasier Sin Varillas'
      });
    }

    if (!sources.length) return;

    var mainWrap = mainImg.closest('.flp-gallery-main');
    var thumbsWrap = root.querySelector('.flp-gallery-thumbs');
    var anchor = mainWrap || thumbsWrap;
    if (!anchor || !anchor.parentNode) return;

    mobileGallery = document.createElement('div');
    mobileGallery.className = 'bp-mobile-gallery';
    mobileGallery.setAttribute('aria-label', 'Galería de imágenes del producto');

    mobileTrack = document.createElement('div');
    mobileTrack.className = 'bp-mobile-gallery-track';

    var nav = document.createElement('div');
    nav.className = 'bp-mobile-gallery-nav';

    mobilePrev = document.createElement('button');
    mobilePrev.type = 'button';
    mobilePrev.className = 'bp-mobile-gallery-arrow bp-mobile-gallery-prev';
    mobilePrev.setAttribute('aria-label', 'Imagen anterior');
    mobilePrev.textContent = '‹';

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'bp-mobile-gallery-dots';

    mobileNext = document.createElement('button');
    mobileNext.type = 'button';
    mobileNext.className = 'bp-mobile-gallery-arrow bp-mobile-gallery-next';
    mobileNext.setAttribute('aria-label', 'Siguiente imagen');
    mobileNext.textContent = '›';

    sources.forEach(function (item, index) {
      var slide = document.createElement('div');
      slide.className = 'bp-mobile-gallery-slide';

      var img = document.createElement('img');
      img.src = item.src;
      img.alt = item.alt;
      img.loading = index === 0 ? 'eager' : 'lazy';
      img.draggable = false;

      slide.appendChild(img);
      mobileTrack.appendChild(slide);

      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'bp-mobile-gallery-dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Ver imagen ' + (index + 1));
      dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      dot.addEventListener('click', function () {
        goToMobileSlide(index, 'smooth');
      });

      dotsWrap.appendChild(dot);
      mobileDots.push(dot);
    });

    nav.appendChild(mobilePrev);
    nav.appendChild(dotsWrap);
    nav.appendChild(mobileNext);

    mobileGallery.appendChild(mobileTrack);
    mobileGallery.appendChild(nav);

    anchor.parentNode.insertBefore(mobileGallery, anchor);

    mobilePrev.addEventListener('click', function () {
      goToMobileSlide(mobileIndex - 1, 'smooth');
    });

    mobileNext.addEventListener('click', function () {
      goToMobileSlide(mobileIndex + 1, 'smooth');
    });

    mobileTrack.addEventListener('scroll', function () {
      if (!isMobileGallery()) return;

      if (mobileScrollRaf) cancelAnimationFrame(mobileScrollRaf);

      mobileScrollRaf = requestAnimationFrame(function () {
        var width = mobileTrack.clientWidth || 1;
        setMobileActive(Math.round(mobileTrack.scrollLeft / width));
      });
    }, { passive: true });

    setMobileActive(0);
  }

  // Desktop thumbnail behavior stays intact.
  if (mainImg && thumbs.length) {
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        mainImg.src = getThumbFull(thumb);
        mainImg.alt = thumb.alt;

        thumbs.forEach(function (t) {
          t.classList.remove('active');
        });

        thumb.classList.add('active');
        mobileIndex = index;
      });
    });

    if (thumbs[0]) thumbs[0].classList.add('active');
  }

  buildMobileGallery();

  window.addEventListener('resize', function () {
    if (!mobileTrack) return;

    if (isMobileGallery()) {
      goToMobileSlide(mobileIndex, 'auto');
    } else {
      mobileTrack.scrollLeft = 0;
    }
  });

  // =========================================================
  // COUNTDOWN TIMER
  // =========================================================

  var timerNums = root.querySelectorAll('.flp-timer-num');

  if (timerNums.length >= 3) {
    var end = Date.now() + (9 * 3600 + 2 * 60 + 19) * 1000;

    function tick() {
      var diff = Math.max(0, end - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      timerNums[0].textContent = String(h).padStart(2, '0');
      timerNums[1].textContent = String(m).padStart(2, '0');
      timerNums[2].textContent = String(s).padStart(2, '0');

      if (diff > 0) setTimeout(tick, 1000);
    }

    tick();
  }

  // =========================================================
  // SCROLL REVEAL
  // =========================================================

  if ('IntersectionObserver' in window) {
    var bpObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          bpObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    root.querySelectorAll('.flp-reveal-bp').forEach(function (element) {
      bpObs.observe(element);
    });
  } else {
    root.querySelectorAll('.flp-reveal-bp').forEach(function (element) {
      element.classList.add('visible');
    });
  }

  // =========================================================
  // LEGACY VARIANT FORM
  // Only runs if this landing still contains the old form.
  // The current kbp bundle selector is managed by bra-pack-buy.liquid.
  // =========================================================

  var form = root.querySelector('form.bp-buy-form');

  if (form) {
    var variantInput = form.querySelector('input[name="id"]');
    var selects = form.querySelectorAll('select[data-option]');
    var variantData = [];

    try {
      var dataEl = root.querySelector('script[data-bp-variants]');
      if (dataEl) variantData = JSON.parse(dataEl.textContent);
    } catch (e) {}

    function syncVariant() {
      if (!variantData.length) return;

      var chosen = Array.from(selects).map(function (select) {
        return select.value;
      });

      var match = variantData.find(function (variant) {
        return variant.options.every(function (option, i) {
          return option === chosen[i];
        });
      });

      var btn = form.querySelector('.bp-atc-btn');
      var unavailEl = form.querySelector('.bp-unavailable');

      if (match) {
        if (variantInput) variantInput.value = match.id;

        if (btn) {
          btn.disabled = !match.available;
          btn.textContent = match.available
            ? (btn.getAttribute('data-label') || 'AGREGAR AL CARRITO')
            : 'AGOTADO';
        }

        if (unavailEl) unavailEl.style.display = 'none';
      } else {
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'NO DISPONIBLE';
        }

        if (unavailEl) unavailEl.style.display = 'block';
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', syncVariant);
    });

    syncVariant();

    form.addEventListener('submit', function () {
      var btn = form.querySelector('.bp-atc-btn');
      if (!btn) return;

      btn.classList.add('loading');
      btn.textContent = 'Agregando...';

      setTimeout(function () {
        btn.classList.remove('loading');
        btn.textContent = btn.getAttribute('data-label') || 'AGREGAR AL CARRITO';
      }, 2500);
    });
  }

  // =========================================================
  // REVIEW CAROUSEL
  // =========================================================

  var bpRevCur = 0;
  var bpRevTot = 5;
  var bpTrack = document.getElementById('bpRevTrack');
  var bpDots = root.querySelectorAll('.flp-dot-bp');

  window.bpGoRev = function (n) {
    bpRevCur = (n + bpRevTot) % bpRevTot;

    if (bpTrack) {
      bpTrack.style.transform = 'translateX(-' + (bpRevCur * 100) + '%)';
    }

    bpDots.forEach(function (dot, i) {
      dot.classList.toggle('flp-dot-on-bp', i === bpRevCur);
    });
  };

  if (bpTrack) {
    setInterval(function () {
      window.bpGoRev(bpRevCur + 1);
    }, 5500);
  }

})();
